module.exports = __webpack_public_path__ + "img/u1522.65e3547c.png";